<mat-toolbar class="dialog-title">
  <span>Usuario</span>
  <div (click)="cerrar()" class="close-dialog">
    <i class="fas fa-times"></i>
  </div>
</mat-toolbar>

<div mat-dialog-content *ngIf="user">
  <mat-form-field appearance="outline" class="field-meta-50">
    <mat-label>Tipo de documento<span style="color: red;">*</span></mat-label>
    <mat-select [(ngModel)]="user.tipoDocumento">
      <mat-option></mat-option>
      <mat-option *ngFor="let tipo of tipoDocumentoDetalleList" [value]="tipo.codigo">
        {{tipo.descripcion}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="field-meta-50">
      <mat-label>N° Documento<span style="color: red;">*</span></mat-label>
      <input matInput [(ngModel)]="user.numeroDocumento" required maxlength="8">
      <i (click)="obtenerDataDni()" class="icon-style fa fa-search" aria-hidden="true"></i>
  </mat-form-field>
  <mat-form-field appearance="outline" class="field-meta-50">
    <mat-label>Apellido paterno<span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="user.apellidoPaterno" style="text-transform:uppercase;" required>
  </mat-form-field>
  <mat-form-field appearance="outline" class="field-meta-50">
    <mat-label>Apellido materno<span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="user.apellidoMaterno" style="text-transform:uppercase;" required>
  </mat-form-field>
  <mat-form-field appearance="outline" class="field-meta-50">
    <mat-label>Nombres<span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="user.nombres" style="text-transform:uppercase;" required>
  </mat-form-field>
  <mat-form-field *ngIf="!this.data.soloLectura" appearance="outline" class="field-meta-50">
    <mat-label>Perfil</mat-label>
    <mat-select  (selectionChange)="limpiarEntidades()" [(ngModel)]="user.perfil">
      <mat-option value="{{this.constantes.TIPO_USUARIO_ADMINISTRADOR_SISTEMA}}">Administrador del Sistema</mat-option>
      <mat-option value="{{this.constantes.TIPO_USUARIO_ADMINISTRADOR}}">Administrador</mat-option>
      <mat-option value="{{this.constantes.TIPO_USUARIO_OPERADOR}}">Operador</mat-option>
      <mat-option value="{{this.constantes.TIPO_USUARIO_CONSULTA}}">Consulta</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="this.data.soloLectura" appearance="outline" class="field-meta-50">
    <mat-label>Perfil</mat-label>
      <input matInput *ngIf="this.constantes.TIPO_USUARIO_ADMINISTRADOR_SISTEMA==user.perfil" value="Administrador del Sistema" readonly>
      <input matInput *ngIf="this.constantes.TIPO_USUARIO_ADMINISTRADOR==user.perfil"  value="Administrador" readonly>
      <input matInput *ngIf="this.constantes.TIPO_USUARIO_OPERADOR==user.perfil"  value="Operador" readonly>
      <input matInput *ngIf="this.constantes.TIPO_USUARIO_CONSULTA==user.perfil"  value="Consulta" readonly>
  </mat-form-field>

  <mat-form-field appearance="outline" class="field-meta-50">
    <mat-label>Número teléfono<span style="color: red;">*</span></mat-label>
    <input maxlength="9" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" matInput [(ngModel)]="user.numeroTelefono" required>
  </mat-form-field>
  <mat-form-field appearance="outline" class="field-meta-50">
    <mat-label>Cargo<span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="user.cargo" required type="text">
  </mat-form-field>

  <mat-form-field appearance="outline" class="field-meta-100">
    <mat-label>Email<span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="user.email" required type="email" email>
  </mat-form-field>

  <div *ngIf="user.perfil && user.perfil!=this.constantes.TIPO_USUARIO_ADMINISTRADOR_SISTEMA">
    <mat-form-field *ngIf="user.entidad && this.entidadList.length>0 && !this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Entidad <span style="color: red;">*</span></mat-label>
      <mat-select (selectionChange)="cargarSelectHijos(user.entidad,undefined,false)" [(ngModel)]="user.entidad.id" required>
        <mat-option></mat-option>
        <mat-option *ngFor="let entidad of entidadList" [value]="entidad.id">
          {{entidad.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="user.entidad && this.entidadList.length>0 && this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Entidad <span style="color: red;">*</span></mat-label>
      <input matInput value="{{user.entidad.nombre}}" readonly>
    </mat-form-field>

    <mat-form-field *ngIf="user.despacho && this.despachoList.length>0 && !this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Despacho </mat-label>
      <mat-select (selectionChange)="cargarSelectHijos(user.despacho,'1',false)" [(ngModel)]="user.despacho.id" >
        <mat-option></mat-option>
        <mat-option *ngFor="let despacho of despachoList" [value]="despacho.id">
          {{despacho.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field  *ngIf="user.despacho && this.despachoList.length>0 && this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Despacho</mat-label>
      <input matInput value="{{user.despacho.nombre}}" readonly>
    </mat-form-field>

    <mat-form-field *ngIf="user.direccionGeneral && this.direccionGeneralList.length>0 && !this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Dirección General</mat-label>
      <mat-select (selectionChange)="cargarSelectHijos(user.direccionGeneral,'2',false)" [(ngModel)]="user.direccionGeneral.id" >
        <mat-option></mat-option>
        <mat-option *ngFor="let direccionGeneral of direccionGeneralList" [value]="direccionGeneral.id">
          {{direccionGeneral.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field  *ngIf="user.direccionGeneral && this.direccionGeneralList.length>0 && this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Dirección General</mat-label>
      <input matInput value="{{user.direccionGeneral.nombre}}" readonly>
    </mat-form-field>


    <mat-form-field *ngIf="user.direccionLinea && this.direccionLineaList.length>0  && !this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Dirección de Línea</mat-label>
      <mat-select (selectionChange)="cargarSelectHijos(user.direccionLinea,'3',false)" [(ngModel)]="user.direccionLinea.id" >
        <mat-option></mat-option>
        <mat-option *ngFor="let direccionLinea of direccionLineaList" [value]="direccionLinea.id">
          {{direccionLinea.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field  *ngIf="user.direccionLinea && this.direccionLineaList.length>0 && this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Dirección de Línea</mat-label>
      <input matInput value="{{user.direccionLinea.nombre}}" readonly>
    </mat-form-field>

    <mat-form-field *ngIf="user.area && this.areaList.length>0  && !this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Área responsable</mat-label>
      <mat-select [(ngModel)]="user.area.id" >
        <mat-option></mat-option>
        <mat-option *ngFor="let area of areaList" [value]="area.id">
          {{area.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field  *ngIf="user.area && this.areaList.length>0 && this.data.soloLectura" appearance="outline" class="field-meta-100">
      <mat-label>Área responsable</mat-label>
      <input matInput value="{{user.area.nombre}}" readonly>
    </mat-form-field>
  </div>

  <div class="dialog-buttons">
    <button mat-raised-button class="btn_olive" (click)="guardar()" [disabled]="datosCompletados()">Registrar</button>&nbsp;
    <button mat-raised-button class="btn_danger" (click)="cerrar()">Cancelar</button>
  </div>
</div>

